/** URL `?tab=` values for goods receipt (GRN) overview. */
export const GoodsReceiptOverviewTabParam = {
  OVERVIEW: "overview",
  LINES: "lines",
} as const;

export function grnOverviewActiveTabId(tab: string | null): string {
  if (tab === GoodsReceiptOverviewTabParam.LINES) return "2";
  return "1";
}

export function searchParamForGrnOverviewTabId(tabId: string): string | null {
  if (tabId === "2") return GoodsReceiptOverviewTabParam.LINES;
  return null;
}

export function isValidGrnOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return (
    tab === GoodsReceiptOverviewTabParam.OVERVIEW ||
    tab === GoodsReceiptOverviewTabParam.LINES
  );
}
